/* -----------------------------------------
Document setup
----------------------------------------- */

Watcher.observe('.js-default-testimonial', blocks => {
  blocks.forEach(block => {
    // Get the motif
    const motif = block.querySelector('.js-default-testimonial__motif');
    // Get the slider container
    const container = block.querySelector('.js-default-testimonial__container');

    // Create an observer to add the in-view class to the slide when the slide is visible
    const IntersObser = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.target.classList.toggle('in-view', entry.isIntersecting);
      });
    }, {
      threshold: 1,
      rootMargin: '100% 0px 100% 0px'
    });
    const resize = () => {
      // Get the slider data
      const data = block.tns.getInfo();
      // get the current slide item
      const slide = data.slideItems[data.index];
      // Get the slide height
      const height = slide.clientHeight;
      // Set the container height to the slide height
      container.style.height = height + 'px';
    };

    // Create a resize observer to watch the element for changes
    const ResizeObser = new ResizeObserver(() => resize());

    // Create the slider
    block.tns = tns({
      container,
      items: 1,
      controls: true,
      nav: false,
      navPosition: 'bottom',
      mouseDrag: true,
      loop: true
    });

    // Get the slider data
    const data = block.tns.getInfo();
    [...data.slideItems].forEach(slide => IntersObser.observe(slide));

    // observe the container
    ResizeObser.observe(container);

    // When the slider index changes
    block.tns.events.on('indexChanged', () => {
      resize();
    });

    // Loop the children of the motif
    [...motif.children].forEach(child => {
      // Create a new MagicScrolls instance for this child
      const Magic = new MagicScrolls(child.parentNode, {
        duration: 1000
      });

      // Set up a new Magic Tween
      Magic.tween(child, percentage => {
        if (window.innerWidth <= 768) return;
        child.style.transform = `translateY(${(-50 + percentage) * -.4}%)`;
      });
    });
  });
});